import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import {
  PageContainer,
  HeroImageSection,
  HeroImageWrap,
  HeroImage,
  MainSection,
  PageTitle,
  PageParagraph,
  StepTitle,
  StepBlock,
  StepImageWrap,
  StepImage,
} from '../SimplePage/SimplePageElements';

// Hero: team strategy / our process (use working Unsplash URLs)
const HERO_IMAGE = 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80';
const HERO_IMAGE_FALLBACK = 'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=900&q=80';
// Step 1: initial call
const IMG_INITIAL_CALL = 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=560&q=80';
// Step 2: discovery – strategy, planning, research
const IMG_DISCOVERY = 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=560&q=80';
const IMG_DISCOVERY_FALLBACK = 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=560&q=80';
// Step 3: marketing contract
const IMG_CONTRACT = 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=560&q=80';

const HowItWorks = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [heroSrc, setHeroSrc] = useState(HERO_IMAGE);
  const [discoverySrc, setDiscoverySrc] = useState(IMG_DISCOVERY);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PageContainer>
        <HeroImageSection>
          <HeroImageWrap>
            <HeroImage
              src={heroSrc}
              alt="Team collaboration and strategy meeting"
              onError={() => setHeroSrc(HERO_IMAGE_FALLBACK)}
            />
          </HeroImageWrap>
        </HeroImageSection>
        <MainSection>
          <Link to="/" style={{ color: '#01bf71', fontWeight: 600, textDecoration: 'none', marginBottom: 32, display: 'inline-block' }}>
            ← Back to Home
          </Link>
          <PageTitle>How it works</PageTitle>
          <PageParagraph>
            We help businesses grow by strengthening their digital presence—from SEO and social
            media to websites and virtual tours. Here’s how we work with you from first contact to
            a signed marketing partnership.
          </PageParagraph>

          <StepBlock>
            <StepTitle>1. Initial call</StepTitle>
            <StepImageWrap>
              <StepImage src={IMG_INITIAL_CALL} alt="Initial consultation call" />
            </StepImageWrap>
            <PageParagraph>
              Reach out via our Get Quote form or contact page. We schedule a short call to
              understand your business, goals, and challenges. This helps us see if we’re a good fit
              and how we can add value.
            </PageParagraph>
          </StepBlock>

          <StepBlock>
            <StepTitle>2. Discovery</StepTitle>
            <StepImageWrap>
              <StepImage
                src={discoverySrc}
                alt="Discovery and strategy planning"
                onError={() => setDiscoverySrc(IMG_DISCOVERY_FALLBACK)}
              />
            </StepImageWrap>
            <PageParagraph>
              We dive deeper into your market, audience, and current marketing. We may review your
              website, social channels, and goals to propose a clear plan—what we’ll do, timelines,
              and what you can expect.
            </PageParagraph>
          </StepBlock>

          <StepBlock>
            <StepTitle>3. Marketing contract</StepTitle>
            <StepImageWrap>
              <StepImage src={IMG_CONTRACT} alt="Partnership and agreement" />
            </StepImageWrap>
            <PageParagraph>
              Once we agree on scope and terms, we sign a marketing contract. Then we get started:
              strategy, content, campaigns, and ongoing support so your business can grow with a
              strong digital foundation.
            </PageParagraph>
          </StepBlock>

          <PageParagraph style={{ marginTop: 40 }}>
            <Link to="/getquote" style={{ color: '#01bf71', fontWeight: 600 }}>
              Get a quote →
            </Link>
          </PageParagraph>
        </MainSection>
      </PageContainer>
      <Footer />
    </>
  );
};

export default HowItWorks;
